// Scoring for a completed marshmallow. More points for toasting closer to the
// band center (quality), for finishing faster (speed), and for longer combos.

import {
  BASE_POINTS,
  QUALITY_BONUS,
  SPEED_REF_SECONDS,
  SPEED_FACTOR,
  COMBO_STEP,
} from './constants';

export interface ScoreInput {
  /** Toast quality, 0..1 (1 = held dead-center in the band the whole time). */
  quality: number;
  /** Seconds taken to toast this marshmallow. */
  timeSeconds: number;
  /** Number of consecutive non-burnt marshmallows BEFORE this one (>= 0). */
  combo: number;
}

const clamp01 = (v: number): number => (v < 0 ? 0 : v > 1 ? 1 : v);

/** Multiplier applied for the current combo length (combo 0 → 1.0x). */
export function comboMultiplier(combo: number): number {
  return 1 + Math.max(0, combo) * COMBO_STEP;
}

/** Points awarded for a single completed marshmallow. */
export function scoreMarshmallow(input: ScoreInput): number {
  const quality = clamp01(input.quality);
  const speedBonus = Math.max(0, SPEED_REF_SECONDS - input.timeSeconds) * SPEED_FACTOR;
  const raw = BASE_POINTS + quality * QUALITY_BONUS + speedBonus;
  return Math.round(raw * comboMultiplier(input.combo));
}
